import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { reactErrorHandler } from '@sentry/react';

import App from './App';
import Aws from './configs/aws';
import Sentry from './configs/sentry';

import './index.css';

Aws.configureAmplify();
Sentry.configure();

const container = document.getElementById('root')!;
const root = createRoot(container, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    // eslint-disable-next-line no-console
    console.error('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: reactErrorHandler(),
});

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
